import React, { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import { Card, CardBody, Row, Col, CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs, H3 } from '../../../AbstractElements';
import { Add } from '../../../Constant';
import SweetAlert from 'sweetalert2';

import { MapContainer, TileLayer, Circle } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import Button from '../../Common/Elements/Button';
import { Trash2 } from 'react-feather';

const MapMock = ({ type, activeCount, position, radius }) => {
    const isGreen = type === 'green';
    const circleColor = isGreen ? '#28a745' : '#007bff';

    return (
        <div style={{
            height: '160px',
            position: 'relative',
            overflow: 'hidden',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px'
        }}>
            <MapContainer
                center={[position.lat, position.lng]}
                zoom={14}
                scrollWheelZoom={false}
                dragging={false}
                zoomControl={false}
                doubleClickZoom={false}
                style={{ height: '100%', width: '100%', zIndex: 1 }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Circle
                    center={position}
                    pathOptions={{ fillColor: circleColor, color: circleColor }}
                    radius={radius}
                />
            </MapContainer>


        </div>
    );
};



function GeoZoneList() {
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [geoZones, setGeoZones] = useState([]);

    const fetchGeoZones = async () => {
        setLoading(true);
        try {
            const endpoint = authState.userRole === 1
                ? '/admin/show-geofence-location'
                : '/show-geofence-location';
            const response = await getClientUrlDataToken(authState.apiUrl, endpoint);
            if (response.status === true) {
                setGeoZones(response.data.data || []);
            } else {
                toast.error(response.data?.message || "Failed to fetch geofence locations");
            }
        } catch (error) {
            console.error("Error fetching geofence locations:", error);
            toast.error("An error occurred while fetching geofence locations");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGeoZones();
    }, [authState.apiUrl, authState.userRole]);

    const handleDelete = (item) => {
        SweetAlert.fire({
            title: 'Confirm deletion?',
            text: 'This action cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then(async (result) => {
            if (result.value) {
                setLoading(true);
                const payload = { location_id: item.id };
                try {
                    const endpoint = authState.userRole === 1
                        ? '/admin/delete-geofence-location'
                        : '/delete-geofence-location';
                    const response = await postClientUrlWithToken(authState.apiUrl, endpoint, payload);
                    if (response.status === 200) {
                        if (response.data.status) {
                            SweetAlert.fire('Deleted!', 'Geofence zone has been deleted.', 'success');
                            fetchGeoZones();
                        } else {
                            toast.error(response.data?.message || "Failed to delete geofence zone");
                        }
                    } else {
                        toast.error("Failed to delete geofence zone");
                    }
                } catch (error) {
                    console.error("Error deleting geozone:", error);
                    toast.error("An error occurred while deleting geofence zone");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const cardStyle = {
        borderRadius: '10px',
        border: '1px solid #eef0f3',
        boxShadow: '0 4px 15px rgba(0,0,0,0.02)'
    };

    const titleStyle = {
        fontSize: '16px',
        fontWeight: '700',
        color: '#212529',
        marginBottom: '6px'
    };

    const subTitleStyle = {
        fontSize: '13px',
        color: '#6c757d',
        marginBottom: '20px'
    };

    const infoStyle = {
        fontSize: '13px',
        color: '#495057',
        fontWeight: '500',
        marginBottom: '20px'
    };



    return (
        <div className="py-2">
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={'Geofence Zones'} parent="Attendance" title={'Geofence Zones'} />

            <Card>
                <CardHeader>
                    <div className="d-flex align-items-center justify-content-between">
                        <H3>Geofence Zones</H3>
                        <div>
                            <button onClick={() => navigate(`${process.env.PUBLIC_URL}/attendance/add-geozone`)} className="btn btn-primary">{Add}</button>
                        </div>
                    </div>
                </CardHeader>
                <CardBody>
                    <Row>
                        {geoZones.length === 0 && !loading ? (
                            <Col xs="12">
                                <div className="text-center py-5 text-muted">
                                    <i className="fa fa-map-o fa-3x mb-3 d-block text-muted"></i>
                                    <h5>No Geofence Zones Found</h5>
                                    <p className="mb-0">Click the button above to add a new geofence zone.</p>
                                </div>
                            </Col>
                        ) : (
                            geoZones.map((item, index) => {
                                const lat = parseFloat(item.latitude);
                                const lng = parseFloat(item.longitude);
                                const position = { lat: isNaN(lat) ? 11.2588 : lat, lng: isNaN(lng) ? 75.7804 : lng };
                                const radius = parseInt(item.radius, 10) || 150;
                                const mockType = index % 2 === 0 ? "green" : "blue";

                                return (
                                    <Col lg="4" md="6" className="mb-4" key={item.id}>
                                        <Card style={cardStyle}>
                                            <MapMock
                                                type={mockType}
                                                activeCount={item.active_count ?? 0}
                                                position={position}
                                                radius={radius}
                                            />
                                            <CardBody className="p-4" style={{ minHeight: '200px' }}>
                                                <div style={titleStyle}>{item.name}</div>
                                                <div style={subTitleStyle}>{item.place}</div>

                                                <div className="d-flex" style={infoStyle}>
                                                    <span style={{ marginRight: '20px' }}>{radius}m radius</span>
                                                    {item.employees_count !== undefined && (
                                                        <span>{item.employees_count} employees</span>
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-center gap-2 mt-3" style={{ width: '100%' }}>
                                                    <Button
                                                        type="button"
                                                        onClick={() => navigate(`${process.env.PUBLIC_URL}/attendance/add-geozone?id=${item.id}`)}
                                                        className={'btn btn-primary'}
                                                        style={{
                                                            flex: 1,
                                                            height: '42px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            fontWeight: '500',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.2s ease-in-out'
                                                        }}

                                                    >
                                                        Edit Zone
                                                    </Button>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDelete(item)}
                                                        style={{
                                                            width: '42px',
                                                            height: '42px',
                                                            backgroundColor: '#ffffff',
                                                            border: '1px solid #d1d5db',
                                                            borderRadius: '6px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.2s ease-in-out'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#fee2e2';
                                                            e.currentTarget.style.borderColor = '#fca5a5';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#ffffff';
                                                            e.currentTarget.style.borderColor = '#d1d5db';
                                                        }}
                                                    >
                                                        <Trash2 size={18} color="#dc2626" />
                                                    </button>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                );
                            })
                        )}
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}

export default GeoZoneList;